'use strict';

angular.module('amexReconciliationApp')
  .service('TransactionsStatusChangeService', function ($rootScope,
                                                        TransactionsModel,
                                                        TransactionSearchModel,
                                                        actionStatusMappings,
                                                        SiteConfigModel,
                                                        LockStatusService,
                                                        TransactionRepository) {
    var self = this;

    var TRANSACTIONS_STATUS_CHANGED = 'transactions_status_changed';

    self.getStatus = function getStatus(transactions, action) {
      return !_.isEmpty(transactions) && _.every(transactions, 'mutableTransactionProperties.' + action);
    };

    self.changeStatus = function changeStatus(transactions) {
      var action = self.currentAction();
      var newStatus = !self.getStatus(transactions, action);
      var transactionIds = _.map(transactions, 'id');
      TransactionsModel.loading(true);

      return TransactionRepository.updateTransactions(
        createUpdateTransactionRequest(transactions, action, newStatus)
      ).then(function () {
        $rootScope.$broadcast(TRANSACTIONS_STATUS_CHANGED, action);
        TransactionsModel.refreshTransactions(transactionIds);
        TransactionsModel.loading(false);
      }).catch(function () {
        TransactionsModel.loading(false);
      });
    };

    self.onTransactionsStatusChanged = function (scope, handler) {
      scope.$on(TRANSACTIONS_STATUS_CHANGED, function (event, action) {
        handler(action);
      });
    };

    self.currentAction = function() {
      return actionStatusMappings[TransactionSearchModel.roleName()];
    };

    self.canBeApprovedOrSubmitted = function (transaction) {
      var approvalSettingOnForRole = SiteConfigModel.approvalSettingOnForRole();
      var transactionIsFullyLocked = LockStatusService.isLocked(transaction);
      var transactionIsPartiallyLocked = LockStatusService.isPartiallyLocked(transaction);
      var siteForbidsPartiallyLockedApprovals = SiteConfigModel.siteConfig().partialLockOptions.approvalsLocked;
      var hasTakenAction = self.getStatus([transaction], self.currentAction());

      return  approvalSettingOnForRole &&
        !transactionIsFullyLocked &&
        !(transactionIsPartiallyLocked && siteForbidsPartiallyLockedApprovals) &&
        !hasTakenAction;
    };

    function createUpdateTransactionRequest(transactionList, action, newStatus) {
      return _.map(transactionList, function (transaction) {
        var obj = {id: transaction.id};
        obj[action] = newStatus;
        return obj;
      });
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TransactionsStatusChangeService.js
// module id = 655
// module chunks = 0